// extracted by mini-css-extract-plugin
module.exports = {"titleCaseHeader":"style_titleCaseHeader__hefcp","titleCaseHeader__title":"style_titleCaseHeader__title__r3X3C","titleCaseHeader__subtitle":"style_titleCaseHeader__subtitle__oThHk"};